import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getInvoiceInfo } from '../../API/FetchCall';
import PdfContainer from './PdfContainer';
import Doc from './DocService';

class transactionDetail extends Component {

      constructor(props) {
    super(props);
    this.state = {
      vendor_id: this.props.match.params.id,
      orders: []
    };


  }

  componentDidMount() {

    let userinfo = JSON.stringify({
      vendor_id: this.state.vendor_id,
    });
    getInvoiceInfo(userinfo).then((response) => {
      if (response.status == 1) {
        console.log('response', response)
        let data = response.results[0];
        this.setState({
          first_name: data.first_name,
          organisation_name: data.organisation_name,
          last_name: data.last_name,
          email_id: data.email_id,
          phone_number: data.phone_number,
          invoice_type: data.invoice_type,
          location: data.location,
          state: data.state,
          address: data.address,
          pin_code: data.pin_code,
          plan_name: data.plan_name,
          created_date: data.created_date,
          amount: data.amount,
          discount_amount: data.discount_amount,
          discount: data.discount,
          plan_price_original: data.plan_price_original,
          invoice_no: data.invoice_no,
          coupon_per: data.coupon_per,
          coupon_amount: data.coupon_amount,
          sgst_per: data.sgst_per,
          sgst_amount: data.sgst_amount,
          chart_discount_amount: data.chart_discount_amount,
          cgst_per: data.cgst_per,
          cgst_amount: data.cgst_amount,
          payment_id: data.payment_id,
          start_date: data.start_date,
          end_date: data.end_date,
          other_description: data.other_description,
          orders: data.orders
        });
      } else {
        console.log(response.status)
      }
    });

  }

  UNSAFE_componentWillMount() {

  }

  onChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState((state) => {
      state[name] = value;
      return state;
    })
  }

  createPdf = (html) => Doc.createPdf(html);


    render() {

      
        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Detail of #{this.state.vendor_id}</h4>
                 
                  
                   <div className="box-shadow-custom">
          <PdfContainer createPdf={this.createPdf}>
            <div className="row invoice-container">
              <div className="col-sm-12" style={{ marginBottom: '32px', marginTop: '25px' }}>
                <div className="col-sm-6 text-right">
                  <h3>Tax Invoice</h3>
                </div>
                <div className="col-sm-6 text-right">
                  <img src="/assets/images/wisdom-logo.png" style={{ width: '82px' }} alt="logo" />
                </div>
              </div>
              <div className="col-md-8 col-sm-12">
                <p>
                  {" "}
                  Wisdom Tech Solutions Private Limited
                  <br />
                  C-6, Gaurav Enclave, 33/1, KHB Main Road, Sultanpalya
                  <br />
                  Bangalore, Karnataka - 560032
                  <br />
                  Contact No - <br />
                  TAN - BLRW03167D
                  <br />
                  PAN - AACCW6395B
                </p>
              </div>
              <div className="col-md-4 col-sm-12">
                <div className="row left-content-invoice">
                  <div className="col-sm-6 text-right">
                    <h6>DATE : </h6>
                  </div>
                  <div className="col-sm-6">
                    <h6> {this.state.created_date}</h6>
                  </div>

                  <div className="col-sm-6  text-right">
                    <h6>INVOICE No : </h6>
                  </div>

                  <div className="col-sm-6">
                    <h6>{this.state.invoice_no}</h6>
                  </div>

                  <div className="col-sm-6  text-right">
                    <h6>Place of Supply : </h6>
                  </div>
                  <div className="col-sm-6">
                    <h6>{this.state.location}</h6>
                  </div>
                  <div className="col-sm-6  text-right">
                    <h6>State of Supply : </h6>
                  </div>

                  <div className="col-sm-6">
                    <h6>{this.state.state}</h6>
                  </div>

                  <div className="col-sm-6  text-right">
                    <h6>Payment Type : </h6>
                  </div>
                  <div className="col-sm-6">
                    <h6> Razorpay</h6>
                  </div>
                  <div className="col-sm-6  text-right">
                    <h6>Reference Number : </h6>
                  </div>
                  <div className="col-sm-6">
                    <h6>{this.state.payment_id}</h6>
                  </div>
                </div>
              </div>
              <div className="col-sm-12">
                <h5>BILL TO</h5>
              </div>
              <div className="col-md-8 col-sm-12">
                <p>
                  {this.state.first_name}  {this.state.last_name}<br />
                  {this.state.address} <br />
                  Contact No - {this.state.phone_number}<br />
                  GST Number
                </p>
              </div>
              <div className="col-md-4 col-sm-12">
                <div className="row left-content-invoice">
                  <div className="col-sm-6 text-right">
                    <h6>Terms : </h6>
                  </div>
                  <div className="col-sm-6">
                    <h6> {this.state.invoice_type}</h6>
                  </div>

                  {/* <div className="col-sm-6  text-right">
                    <h6>Plan : </h6>
                  </div>

                  <div className="col-sm-6">
                    <h6>{this.state.plan_name}</h6>
                  </div> */}

                  {/* <div className="col-sm-6  text-right">
                    <h6>Package : </h6>
                  </div>
                  <div className="col-sm-6">
                    <h6>Yearly</h6>
                  </div> */}
                  {/* <div className="col-sm-6  text-right">
                    <h6>Start Date : </h6>
                  </div>

                  <div className="col-sm-6">
                    <h6> {this.state.start_date}</h6>
                  </div>

                  <div className="col-sm-6  text-right">
                    <h6>End date : </h6>
                  </div>
                  <div className="col-sm-6">
                    <h6> {this.state.end_date}</h6>
                  </div> */}
                </div>
              </div>
              <div className="col-sm-12">
                <div className="back-drop">
                  <img src="/assets/dashboard/logo.svg" alt="logo" />
                </div>
                <table>
                  <thead>
                    <tr>
                      <th>DESCRIPTION</th>
                      <th>QTY </th>
                      <th>AMOUNT</th>
                      <th>Duration</th>
                      <th>CGST</th>
                      <th>SGST</th>
                      <th>Net Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.orders.map((item, i) => {
                      return (
                        <tr>
                          <td><b>{item.organisation_name}</b> <br />{item.description} - {item.category_name} </td>
                          <td>1 </td>
                          <td>₹ {item.base_price}</td>
                          <td>{`${item.start_date} - ${item.end_date}`}</td>
                          <td>-</td>
                          <td>-</td>

                          <td className="text-right">₹ {parseFloat(item.base_price).toFixed(2)} </td>
                        </tr>
                      )
                    })}


                    <tr>
                      <td colSpan="4" rowspan="7" style={{ verticalAlign: "baseline" }}>

                      </td>
                      <td rowspan="8">Total</td>

                      <td>Sub total </td>
                      <td className="text-right">₹ {parseFloat(this.state.plan_price_original).toFixed(2)}  </td>
                    </tr>
                    {this.state.discount_amount > 0 &&
                      <tr>
                        <td>Early Bird Offer </td>
                        <td className="text-right">₹ {parseFloat(this.state.discount_amount).toFixed(2)}  </td>
                      </tr>
                    }
                    {this.state.chart_discount_amount > 0 &&
                      <tr>
                        <td>Offer </td>
                        <td className="text-right">₹ {parseFloat(this.state.chart_discount_amount).toFixed(2)}  </td>
                      </tr>
                    }
                    {this.state.coupon_per > 0 && (
                      <tr>
                        <td>Coupon Discount ({this.state.coupon_per}%)</td>
                        <td className="text-right">₹ {parseFloat(this.state.coupon_amount).toFixed(2)}  </td>
                      </tr>
                    )}
                    <tr>
                      <td>CGST ({this.state.cgst_per}%) </td>
                      <td className="text-right"> {parseFloat(this.state.cgst_amount).toFixed(2)} </td>
                    </tr>
                    <tr>
                      <td>SGST ({this.state.sgst_per}%) </td>
                      <td className="text-right"> {parseFloat(this.state.sgst_amount).toFixed(2)} </td>
                    </tr>
                    <tr>

                      <td>Total Amount  </td>
                      <td className="text-right">₹ {parseFloat(this.state.amount).toFixed(2)}  </td>
                    </tr>
                    <tr>

                      <td>Payment Received  </td>
                      <td className="text-right">₹ {parseFloat(this.state.amount).toFixed(2)}</td>
                    </tr>
                  </tbody>
                </table>
                <div className="text-left">
                  <p>*This is a computer generated E-mail and doesn’t require a physical copy </p>
                </div>
                <div className="text-right">
                  <h4> <b>PAID</b></h4>
                  <h4> Wisdom Tech Solutions Private Limited    </h4>
                  <p>Authorised Signatory </p>
                </div>
                <div className="text-center" >
                  <h4 style={{ marginTop: "30px", fontWeight: "bold" }}>Thank you for the payment! You just made our day              </h4>
                </div>
              </div>
            </div>
          </PdfContainer>
        </div> 

                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default transactionDetail;


// WEBPACK FOOTER //
// ./src/components/bewise/transactionDetail.jsx